export const REMEDIES_HEADLINES = {
  en: "Discover Your Dosha Remedies",
  hi: "अपने दोष के उपाय जानें",
} as const;
